import React from "react";
import { useInView } from "../hooks/useInView";

/**
 * Wraps children in a scroll-reveal animation.
 *
 * Props:
 *   delay     – ms delay before the animation plays (for staggering siblings)
 *   direction – "up" | "down" | "left" | "right"  (default: "up")
 *   distance  – px the element travels before settling (default: 28)
 *   duration  – ms the animation takes (default: 550)
 *   threshold – 0-1 how much of the element must be visible (default: 0.12)
 *   className – forwarded to the wrapper div
 *   style     – forwarded to the wrapper div
 */
const DIRECTIONS = {
  up:    "translateY(VALpx)",
  down:  "translateY(-VALpx)",
  left:  "translateX(VALpx)",
  right: "translateX(-VALpx)",
};

const Reveal = ({
  children,
  delay = 0,
  direction = "up",
  distance = 28,
  duration = 550,
  threshold = 0.12,
  className = "",
  style = {},
}) => {
  const [ref, inView] = useInView({ threshold });

  const hiddenTransform = (DIRECTIONS[direction] || DIRECTIONS.up).replace(
    "VAL",
    distance
  );

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translate(0,0)" : hiddenTransform,
        transition: `opacity ${duration}ms ease ${delay}ms, transform ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
        willChange: "opacity, transform",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default Reveal;
